<template>
    <page-loading-animation v-if="isLoading" :is-loading="isLoading" />

    <div v-else-if="hasLoadError" class="d-flex align-center justify-center pa-4">
        <v-alert type="error"> Failed to load profile data. Please try again later. </v-alert>
    </div>

    <div v-else-if="fullCurrentUserData?.userData">
        <!--Header-->
        <div class="d-flex align-center justify-space-between">
            <page-title icon="user" info="View and administer your account." title="My Profile" />

            <edit-icon @click.native="editItem" :isActive="!isReadOnly" />
        </div>

        <v-divider class="greyD my-4" />

        <!--Form-->
        <user-form @emitReloadPage="reloadPage" :fullUserData="fullCurrentUserData" :isReadOnly="isReadOnly" :organisationsData="organisationsData" />
    </div>
</template>

<script>
import UserForm from '@/views/users/userForm/UserForm'

export default {
    name: 'MyProfile',

    components: { UserForm },

    data: () => ({
        isLoading: true,
        isReadOnly: true,
        hasLoadError: false,

        // Data
        fullCurrentUserData: null,
        organisationsData: [] // Add this to store organisations data
    }),

    methods: {
        editItem() {
            const t = this
            t.isReadOnly = !t.isReadOnly
        },

        async loadData() {
            const t = this
            t.isLoading = true
            t.hasLoadError = false

            try {
                await Promise.all([t.loadFullCurrentUserData(), t.loadOrganisationsData()])
            } catch (error) {
                console.error('Error loading profile data:', error)
                t.hasLoadError = true
            } finally {
                t.isLoading = false
            }
        },

        async loadFullCurrentUserData() {
            const t = this
            const CURRENT_USER_AUTH = t.currentUserAuth

            if (!CURRENT_USER_AUTH?.uid) {
                throw new Error('No user authentication found')
            }

            // Fetch the data
            const RESPONSE = await t.MIX_redis_getFullUserData(CURRENT_USER_AUTH.uid)

            // Handle any errors
            if (RESPONSE.hasErrors) {
                console.error('Error getting full User data: ', RESPONSE.error)
                throw new Error(RESPONSE.error)
            }

            if (!RESPONSE.data) {
                throw new Error('No user data received')
            }

            // Assign the data
            t.fullCurrentUserData = RESPONSE.data
        },

        async loadOrganisationsData() {
            const t = this
            // Use MIX_redis_getAll as shown in the mixins
            const RESPONSE = await t.MIX_redis_getAll('organisation')

            if (RESPONSE.hasErrors) {
                console.error('Error loading organisations:', RESPONSE.error)
                throw new Error(RESPONSE.error)
            }

            t.organisationsData = RESPONSE.data || []
        },

        async reloadPage() {
            const t = this
            await t.loadData()
            t.editItem()
        }
    },

    created() {
        this.loadData()
    }
}
</script>
